declare const angular: any;

export const getAngularUser = () => {
    try {
        if (typeof angular === 'undefined' || !document?.body) {
            return null;
        }

        const angularElement = angular.element(document.body);
        if (!angularElement || typeof angularElement.scope !== 'function') {
            return null;
        }

        const scope = angularElement.scope();
        return scope?.$root?.user || null;
    } catch (error) {
        console.error('Failed to access Angular user:', error);
        return null;
    }
};

/**
 * Tells the AngularJS shell a session just started, which is what loads the user and redirects to the
 * return path (appCtrl 'user:signin'). Falls back to a full reload if Angular is not around.
 */
export const notifyAngularSignIn = (): void => {
    try {
        const injector = angular?.element(document.body)?.injector();
        const rootScope = injector?.get('$rootScope');
        if (!rootScope) {
            window.location.assign('/');
            return;
        }
        rootScope.$applyAsync(() => rootScope.$broadcast('user:signin'));
    } catch (error) {
        console.error('Failed to notify Angular about the sign in:', error);
        window.location.assign('/');
    }
};
